
import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { 
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Checkbox } from "@/components/ui/checkbox";
import { RecipeDifficulty } from "../../types";

interface CookingDetailsProps {
  prepTime: string;
  setPrepTime: (value: string) => void;
  cookTime: string;
  setCookTime: (value: string) => void;
  totalTime: string;
  setTotalTime: (value: string) => void;
  servings: number;
  setServings: (value: number) => void;
  difficulty: RecipeDifficulty;
  setDifficulty: (value: RecipeDifficulty) => void;
  kidFriendly: boolean;
  setKidFriendly: (value: boolean) => void;
}

const CookingDetails: React.FC<CookingDetailsProps> = ({
  prepTime,
  setPrepTime,
  cookTime,
  setCookTime,
  totalTime,
  setTotalTime,
  servings,
  setServings,
  difficulty,
  setDifficulty,
  kidFriendly,
  setKidFriendly,
}) => {
  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="space-y-2">
          <Label htmlFor="prepTime">Prep Time</Label>
          <Input
            id="prepTime"
            value={prepTime}
            onChange={(e) => setPrepTime(e.target.value)}
            placeholder="e.g. 15 mins"
            required
          />
        </div>
        
        <div className="space-y-2">
          <Label htmlFor="cookTime">Cook Time</Label>
          <Input
            id="cookTime"
            value={cookTime}
            onChange={(e) => setCookTime(e.target.value)}
            placeholder="e.g. 30 mins"
            required
          />
        </div>
        
        <div className="space-y-2">
          <Label htmlFor="totalTime">Total Time</Label>
          <Input
            id="totalTime"
            value={totalTime}
            onChange={(e) => setTotalTime(e.target.value)}
            placeholder="e.g. 45 mins"
            required
          />
        </div>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="space-y-2">
          <Label htmlFor="servings">Servings</Label>
          <Input
            id="servings"
            type="number"
            min="1"
            value={servings}
            onChange={(e) => setServings(parseInt(e.target.value))}
            required
          />
        </div>
        
        <div className="space-y-2">
          <Label htmlFor="difficulty">Difficulty</Label>
          <Select 
            value={difficulty}
            onValueChange={(value) => setDifficulty(value as RecipeDifficulty)}
          >
            <SelectTrigger id="difficulty">
              <SelectValue placeholder="Select difficulty" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="Easy">Easy</SelectItem>
              <SelectItem value="Medium">Medium</SelectItem>
              <SelectItem value="Hard">Hard</SelectItem>
            </SelectContent>
          </Select>
        </div>
        
        <div className="space-y-2">
          <Label htmlFor="kidFriendly" className="block mb-2">Kid Friendly</Label>
          <div className="flex items-center space-x-2">
            <Checkbox
              id="kidFriendly"
              checked={kidFriendly}
              onCheckedChange={(checked) => setKidFriendly(checked === true)}
            />
            <label
              htmlFor="kidFriendly"
              className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
            >
              This recipe is kid friendly
            </label>
          </div>
        </div>
      </div>
    </>
  );
};

export default CookingDetails;
